export abstract class Action<Payload, State> {
    public error = false;
    public instance: Action<Payload, State> | null = null;
    constructor(public payload?: Payload) {
        if (this.payload instanceof Error) {
            this.error = true;
        }
        this.instance = this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    create(): any {
        return Object.assign({}, this);
    }
    abstract reducer(state: State): State;
}

export type ActionPayload<A> = A extends Action<infer P, any> ? P : never;
export type ActionPayloadOK<A> = A extends Action<infer P | Error, any>
    ? P
    : never;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type ActionPayloadError<A> = Error;
export type ActionState<A> = A extends Action<any, infer S> ? S : never;
